import { createText, createLine } from './helpers';

export const simpleAppreciation = () => ({
  id: 'simple-appreciation',
  name: 'Simple Appreciation',
  thumbnail: '/assets/diploma-templates/02_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 97,
        top: 205,
        fontSize: 64,
        fontFamily: 'Times New Roman',
        width: 600
      }),
      createText({
        text: 'OF APPRECIATION',
        left: 222,
        top: 280,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 350,
        fontWeight: '600'
      }),
      createText({
        text: 'proudly presented to',
        left: 247,
        top: 314,
        fontSize: 16,
        fontFamily: 'EB Garamond',
        width: 300,
        color: '#353535',
        fontStyle: 'italic'
      }),
      createText({
        text: '{learner_name}',
        left: 97,
        top: 463,
        fontSize: 82,
        fontFamily: 'Great Vibes',
        width: 600
      }),
      createLine({ left: 154, top: 543, width: 486 }),
      createText({
        text: 'for completing the course',
        left: 222,
        top: 569,
        fontSize: 16,
        fontFamily: 'EB Garamond',
        fontStyle: 'italic',
        fontWeight: '300',
        width: 350,
        color: '#353535'
      }),
      createText({
        text: '{program_name}',
        left: 60,
        top: 613,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 674
      }),
      createText({
        text: 'on',
        left: 222,
        top: 662,
        fontSize: 16,
        fontFamily: 'EB Garamond',
        fontStyle: 'italic',
        fontWeight: '300',
        color: '#353535',
        width: 350
      }),
      createText({
        text: '{completion_date}',
        left: 60,
        top: 706,
        fontSize: 25,
        fontFamily: 'Lato',
        width: 674
      }),
      createText({
        text: 'John Smith',
        left: 60,
        top: 855,
        fontSize: 41,
        fontFamily: 'Great Vibes',
        width: 250
      }),
      createLine({ left: 93, top: 896, width: 214 }),
      createText({
        text: 'JOHN SMITH',
        left: 60,
        top: 891,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 250,
        color: '#444545'
      }),
      createText({
        text: 'director',
        left: 60,
        top: 908,
        fontSize: 10,
        fontFamily: 'Lato',
        width: 250,
        color: '#353535'
      }),
      createText({
        text: 'Jane Doe',
        left: 484,
        top: 855,
        fontSize: 41,
        fontFamily: 'Great Vibes',
        width: 250
      }),
      createLine({ left: 487, top: 896, width: 214 }),
      createText({
        text: 'JANE DOE',
        left: 484,
        top: 891,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 250,
        color: '#444545'
      }),
      createText({
        text: 'manager',
        left: 484,
        top: 908,
        fontSize: 10,
        fontFamily: 'Lato',
        width: 250,
        color: '#353535'
      })
    ],
    backgroundColor: '#fffdf9',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/02_background.svg',
      key: null
    }
  }
});
